module.exports = __webpack_public_path__ + "static/media/img20.d38391a1.jpg";